
    import './styles.scoped.css';
    export default {
  "code-editor": "_code-editor_86fry_13",
  "pane": "_pane_86fry_196",
  "pane__close-container": "_pane__close-container_86fry_205",
  "pane__list": "_pane__list_86fry_213",
  "pane__table": "_pane__table_86fry_220",
  "pane__item": "_pane__item_86fry_225",
  "pane__item--highlighted": "_pane__item--highlighted_86fry_228",
  "pane__location": "_pane__location_86fry_234",
  "pane__description": "_pane__description_86fry_234",
  "focus-lock": "_focus-lock_86fry_249",
  "resizable-box": "_resizable-box_86fry_266",
  "resizable-box-handle": "_resizable-box-handle_86fry_271",
  "editor": "_editor_86fry_287",
  "status-bar": "_status-bar_86fry_315",
  "status-bar__left": "_status-bar__left_86fry_324",
  "status-bar__right": "_status-bar__right_86fry_331",
  "status-bar__language-mode": "_status-bar__language-mode_86fry_335",
  "status-bar__cursor-position": "_status-bar__cursor-position_86fry_335",
  "status-bar__cog-button": "_status-bar__cog-button_86fry_340",
  "tab-button": "_tab-button_86fry_347",
  "tab-button--active": "_tab-button--active_86fry_360",
  "tab-button--disabled": "_tab-button--disabled_86fry_373",
  "loading-screen": "_loading-screen_86fry_404",
  "error-screen": "_error-screen_86fry_405"
};
  